<template>
  <router-link class="card-client" :to="client.url" target="_blank">
    <img :src="image" :alt="name" />
  </router-link>
</template>

<script>
export default {
  name: 'CardClient',
  components: {},
  props: {
    client: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      return require(`@/assets/icons/trusticons/${this.client.image}`)
    },
    name() {
      return this.client.name ? this.client.name + ' logo' : ''
    }
  }
}
</script>
